import type { Placement } from '@popperjs/core';
import React from 'react';
import { Manager, Popper, Reference } from 'react-popper';
import * as styles from './TutorialBeacon.module.scss';
import useAppSelector from '../../app/redux/useAppSelector';

type ReferenceProps = React.ComponentProps<typeof Reference>;
type PopperRef = Parameters<ReferenceProps['children']>[0]['ref'];

interface TutorialBeaconProps {
  children(props: { ref: PopperRef }): JSX.Element;
  id: string;
  hide?: boolean;
  placement?: Placement;
}

const TutorialBeacon = ({
  children,
  hide,
  placement = 'bottom',
  id,
}: TutorialBeaconProps) => {
  const isActive = useAppSelector(
    (state) => !!state.onboarding.activeBeacons[id],
  );

  return (
    <Manager>
      <Reference>{({ ref }) => children({ ref })}</Reference>
      {isActive && !hide && (
        <Popper
          strategy="fixed"
          modifiers={[
            { name: 'arrow', enabled: false },
            { name: 'hide', enabled: false },
            { name: 'flip', enabled: false },
            { name: 'preventOverflow', enabled: false },
            { name: 'offset', options: { offset: [0, 5] } },
          ]}
          placement={placement}
        >
          {({ ref, style }) => (
            <div ref={ref} style={style}>
              <div className={styles.dot} />
            </div>
          )}
        </Popper>
      )}
    </Manager>
  );
};

export default TutorialBeacon;
